module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag44_2097AT.460cb8c3.jpg";